/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesContractWithPaymentsResponseDto } from '../../models/sales-contract-with-payments-response-dto';

export interface ContractsControllerFindByTenantAndIdWithPayments$Params {
  tenant: string;
  id: string;
}

export function contractsControllerFindByTenantAndIdWithPayments(http: HttpClient, rootUrl: string, params: ContractsControllerFindByTenantAndIdWithPayments$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesContractWithPaymentsResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, contractsControllerFindByTenantAndIdWithPayments.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesContractWithPaymentsResponseDto>;
    })
  );
}

contractsControllerFindByTenantAndIdWithPayments.PATH = '/o2-sales/contracts/tenant/{tenant}/{id}/with-payments';
